import { Script } from 'gatsby';
import React from 'react';
import { useGetDrupalCustomConfig } from 'src/hooks/useGetDrupalCustomConfig';
import { buildSmartScriptProcessing } from './helpers/buildSmartScriptProcessing';

export const AppsFlyer = ({ langcode }: { langcode?: Languages }) => {
  const appsflyerSettings = useGetDrupalCustomConfig(langcode ?? 'en')?.nerd_appsflyer_settings;
  if (!appsflyerSettings) {
    return null;
  }

  const { smartscript_sdk_script: sdkScript, onelink_domain: domain } = appsflyerSettings;

  if (!sdkScript || !domain) {
    return null;
  }

  const smartScriptInit = buildSmartScriptProcessing(sdkScript, domain);

  if (!smartScriptInit) {
    console.error(
      'Invalid AppsFlyer SmartScript configuration. Please check the script and domain.',
    );
    return null;
  }

  return (
    <>
      <Script
        type="text/javascript"
        id="appsflyer-smartscript-sdk"
        defer
        // @see https://github.com/AppsFlyerSDK/appsflyer-onelink-smart-script
        src="https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js"
      />
      <Script type="text/javascript" id="appsflyer-smartscript-handler" defer>
        {smartScriptInit}
      </Script>
    </>
  );
};
